import { useEffect, useState } from "react";
import { CardTaps } from "../../../theme/Component/CardTaps";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _FunctionalID, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { SelectorOffice } from "../../../bpm/config/Componentes/SelectorOffice";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BpmServiceall } from "../../../../core/services/BpmServiceall";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { BusinessRoleCatalog } from "./RolesComponents/BusinessRoleCatalog";
import { Modal } from "../../../theme/Component/Modal";
import { WorkGroup } from "./RolesComponents/WorkGroup";

interface Props {
    IDLn: number;
}
export const WorkGroupByIDLn = ({ IDLn }: Props) => {

    const { instance, bean, setBean } = useDataBean(_FunctionalID);
    const [idOffice, setIdOffice] = useState(undefined);
    const [wroker, setWorker] = useState<any>({});
    const [workersList, setWorkersList] = useState([]);
    const bpmService = new BpmServiceall();
    const [confirm2, setConfirm2] = useState<any>({ name: 'Confirmación', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });    
    const [modalAddRole, setModalAddRole] = useState<any>({ name: 'Agregar Rol', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const [indexTap, setIndexTap] = useState(0);
    let taps = [
        { id: 0, name: 'Equipo de Trabajo', disable: false },
        { id: 1, name: 'Asignaciones', disable: false }
    ];

    useEffect(() => {

        if (IDLn !== 0) {
            instance.getFunctionalIDByKey(IDLn).then((data: any) => {
                setBean(data);
            });
        }

    }, [IDLn]);

    const getMemberList = (_idOffice: number) => {
        _single.spinner(true);
        bpmService.getWorkGroupMemberCatalog(bean.IDLn, _idOffice)
            .subscribe((resp: any) => {
                setWorkersList(resp.DataBeanProperties.ObjectValue)
                _single.spinner(false);
            })
    }

    const takeOutButton = () => {
        const botones = [
            { titulo: 'Retirar de la lista', icono: 'ri-file-user-line', visible: true, evento: () => { setConfirm2({ ...confirm2, 'view': true }) } },
            { titulo: 'Asignar rol al usuario', icono: 'ri-file-add-line', visible: true, evento: () => { setModalAddRole({ ...modalAddRole, 'view': true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const removeWorkGroupMember = () => {
        _single.spinner(true);
        bpmService.removeWorkGroupMember(bean.IDLn, wroker.IDAccount, idOffice)
            .subscribe((resp) => {
                _single.spinner(false);
                getMemberList(idOffice)
                setConfirm2({ ...confirm2, 'view': false })
            })

    }
    const addMember = (selectedMember: any) => {
        _single.spinner(true);
        bpmService.addWorkGroupMember(bean.IDLn, selectedMember.IDAccount, idOffice)
            .subscribe((resp) => {
                _single.spinner(false);
                getMemberList(idOffice)
            })
    }


    const head = [
        { title: 'ID', property: 'IDAccount' },
        { title: 'Identificación', property: 'AccountID' },
        { title: 'Nombre', property: 'AccountName' },
        { title: 'Rol', property: 'BusinessRoleName' },
    ];

    return (
        <div className="row">
            <div className="col">
                <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >
                    {/* <PrintJson json={inboxList}/> */}
                    {indexTap === 0 &&
                        <div className="row">
                            <div className="col-md-12">
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5>{bean.Name}</h5>
                                        </div>
                                        <div className="col-md-6 justify-content-end">
                                            <SelectorOffice idSelector={idOffice} titulo="En la sucursal" onChange={(e: any) => { setIdOffice(parseInt(e)); getMemberList(parseInt(e)) }} />
                                        </div>
                                        <div className="col-md-6 justify-content-end">
                                            <AccountEditor disabled={idOffice == 0} idAccount={bean.IDBoss} label="Añadir personal" onChange={addMember} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 m-3 mt-5">
                                            <BasicTable listButtons={takeOutButton()} head={head} body={idOffice === 0 ? [] : workersList} rowSet={setWorker} ></BasicTable>
                                        </div>
                                    </div></div>
                            </div>
                        </div>
                    }
                    {indexTap === 1 &&
                        <div className="row">
                            <div className="col-md-12">

                                <BusinessRoleCatalog IDLnFunctional={bean.IDLn} />
                            </div>
                        </div>
                    }
                </CardTaps>
            </div>
            <div className="col-md-12">
                <ModalConfirm modal={confirm2} updateModal={setConfirm2} eventModal={removeWorkGroupMember}>
                    <></>
                </ModalConfirm>
                <Modal modal={modalAddRole} updateModal={setModalAddRole} eventModal={""}>
                    <>
                        <WorkGroup _update={() => { getMemberList(idOffice); }} _IdLnOffice={bean.IDLn} _IDWorkGroupMember={wroker.IDWorkGroupMember} />
                    </>
                </Modal>
            </div>
        </div>
    )
}